import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { oauthClient } from '../../apis/OAuthClient';
import { LoadingOverlay } from '../../components/ui/LoadingOverlay';

type AuthCheckStatus = 'checking' | 'authenticated' | 'unauthenticated';

interface ProtectedRouteProps {
  children: JSX.Element;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const [status, setStatus] = useState<AuthCheckStatus>('checking');
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      if (!oauthClient.getAccessToken()) {
        if (!cancelled) setStatus('unauthenticated');
        return;
      }

      const isValid = await oauthClient.validateTokenWithSecondService();
      if (!cancelled) setStatus(isValid ? 'authenticated' : 'unauthenticated');
    };

    verify();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'checking') return <LoadingOverlay />;
  if (status === 'unauthenticated') return <Navigate to="/login" replace state={{ from: location }} />;

  return children;
};
